import _objectSpread from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _slicedToArray from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import { readConfObject } from '@jbrowse/core/configuration';
import { clamp, featureSpanPx } from '@jbrowse/core/util';
// locals
import { getOrigin, getScale } from './util';
// avoid drawing negative width features for SVG exports
function fillRectCtx(x, y, width, height, ctx, color) {
  if (width < 0) {
    x += width;
    width = -width;
  }
  if (height < 0) {
    y += height;
    height = -height;
  }
  if (color) {
    ctx.fillStyle = color;
  }
  ctx.fillRect(x, y, width, height);
}
var fudgeFactor = 0.4;
var clipHeight = 2;
export function drawXY(ctx, props) {
  var features = props.features,
    bpPerPx = props.bpPerPx,
    regions = props.regions,
    scaleOpts = props.scaleOpts,
    unadjustedHeight = props.height,
    config = props.config,
    ticks = props.ticks,
    displayCrossHatches = props.displayCrossHatches,
    _props$offset = props.offset,
    offset = _props$offset === void 0 ? 0 : _props$offset,
    colorCallback = props.colorCallback,
    Color = props.Color;
  var _regions = _slicedToArray(regions, 1),
    region = _regions[0];
  var width = (region.end - region.start) / bpPerPx;
  // the adjusted height takes into account YSCALEBAR_LABEL_OFFSET from the
  // wiggle display, and makes the height of the actual drawn area add
  // "padding" to the top and bottom of the display
  var height = unadjustedHeight - offset * 2;
  var filled = readConfObject(config, 'filled');
  var clipColor = readConfObject(config, 'clipColor');
  var summaryScoreMode = readConfObject(config, 'summaryScoreMode');
  var pivotValue = readConfObject(config, 'bicolorPivotValue');
  var minSize = readConfObject(config, 'minSize');
  var scale = getScale(_objectSpread({}, scaleOpts, {
    range: [0, height]
  }));
  var originY = getOrigin(scaleOpts.scaleType);
  var _scale$domain = scale.domain(),
    _scale$domain2 = _slicedToArray(_scale$domain, 2),
    niceMin = _scale$domain2[0],
    niceMax = _scale$domain2[1];
  var toY = function toY(n) {
    return clamp(height - (scale(n) || 0), 0, height) + offset;
  };
  var toOrigin = function toOrigin(n) {
    return toY(originY) - toY(n);
  };
  var getHeight = function getHeight(n) {
    return filled ? toOrigin(n) : Math.max(minSize, 1);
  };
  var hasClipping = false;
  var prevLeftPx = -Infinity;
  var reducedFeatures = [];
  var crossingOrigin = niceMin < pivotValue && niceMax > pivotValue;
  // we handle whiskers separately to render max row, min row, and avg in three
  // passes. this reduces subpixel rendering issues. note: for stylistic
  // reasons, clipping indicator is only drawn for score, not min/max score
  if (summaryScoreMode === 'whiskers') {
    var lastCol;
    var lastMix;
    var _iterator = _createForOfIteratorHelper(features.values()),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var feature = _step.value;
        var _featureSpanPx = featureSpanPx(feature, region, bpPerPx),
          _featureSpanPx2 = _slicedToArray(_featureSpanPx, 2),
          leftPx = _featureSpanPx2[0],
          rightPx = _featureSpanPx2[1];
        if (feature.get('summary')) {
          var w = Math.max(rightPx - leftPx + fudgeFactor, minSize);
          var max = feature.get('maxScore');
          var c = colorCallback(feature, max);
          var effectiveC = crossingOrigin ? c : c === lastCol ? lastMix : lastMix = Color(c).lighten(0.4).toString();
          fillRectCtx(leftPx, toY(max), w, getHeight(max), ctx, effectiveC);
          lastCol = c;
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    lastMix = undefined;
    lastCol = undefined;
    var _iterator2 = _createForOfIteratorHelper(features.values()),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var _feature2 = _step2.value;
        var _featureSpanPx3 = featureSpanPx(_feature2, region, bpPerPx),
          _featureSpanPx4 = _slicedToArray(_featureSpanPx3, 2),
          _leftPx = _featureSpanPx4[0],
          _rightPx = _featureSpanPx4[1];
        var score = _feature2.get('score');
        var _max = _feature2.get('maxScore');
        var min = _feature2.get('minScore');
        var summary = _feature2.get('summary');
        var _c = colorCallback(_feature2, score);
        var _effectiveC = crossingOrigin && summary ? _c === lastCol ? lastMix : lastMix = Color(colorCallback(_feature2, _max)).mix(Color(colorCallback(_feature2, min))).toString() : _c;
        var _w = Math.max(_rightPx - _leftPx + fudgeFactor, minSize);
        // create reduced features, avoiding multiple features per px
        if (Math.floor(_leftPx) !== Math.floor(prevLeftPx)) {
          reducedFeatures.push(_feature2);
          prevLeftPx = _leftPx;
        }
        hasClipping = hasClipping || score < niceMin || score > niceMax;
        fillRectCtx(_leftPx, toY(score), _w, getHeight(score), ctx, _effectiveC);
        lastCol = _c;
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
    lastMix = undefined;
    lastCol = undefined;
    var _iterator3 = _createForOfIteratorHelper(features.values()),
      _step3;
    try {
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        var _feature3 = _step3.value;
        var _featureSpanPx5 = featureSpanPx(_feature3, region, bpPerPx),
          _featureSpanPx6 = _slicedToArray(_featureSpanPx5, 2),
          _leftPx2 = _featureSpanPx6[0],
          _rightPx2 = _featureSpanPx6[1];
        if (_feature3.get('summary')) {
          var _min = _feature3.get('minScore');
          var _c2 = colorCallback(_feature3, _min);
          var _w2 = Math.max(_rightPx2 - _leftPx2 + fudgeFactor, minSize);
          var _effectiveC2 = crossingOrigin ? _c2 : _c2 === lastCol ? lastMix : lastMix = Color(_c2).darken(0.4).toString();
          fillRectCtx(_leftPx2, toY(_min), _w2, getHeight(_min), ctx, _effectiveC2);
          lastCol = _c2;
        }
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }
  } else {
    var _iterator4 = _createForOfIteratorHelper(features.values()),
      _step4;
    try {
      for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
        var _feature4 = _step4.value;
        var _featureSpanPx7 = featureSpanPx(_feature4, region, bpPerPx),
          _featureSpanPx8 = _slicedToArray(_featureSpanPx7, 2),
          _leftPx3 = _featureSpanPx8[0],
          _rightPx3 = _featureSpanPx8[1]; // create reduced features, avoiding multiple features per px
        if (Math.floor(_leftPx3) !== Math.floor(prevLeftPx)) {
          reducedFeatures.push(_feature4);
          prevLeftPx = _leftPx3;
        }
        var _score = _feature4.get('score');
        var _c3 = colorCallback(_feature4, _score);
        hasClipping = hasClipping || _score < niceMin || _score > niceMax;
        var _w3 = Math.max(_rightPx3 - _leftPx3 + fudgeFactor, minSize);
        if (summaryScoreMode === 'max') {
          var s = _feature4.get('summary') ? _feature4.get('maxScore') : _score;
          fillRectCtx(_leftPx3, toY(s), _w3, getHeight(s), ctx, _c3);
        } else if (summaryScoreMode === 'min') {
          var _s = _feature4.get('summary') ? _feature4.get('minScore') : _score;
          fillRectCtx(_leftPx3, toY(_s), _w3, getHeight(_s), ctx, _c3);
        } else {
          fillRectCtx(_leftPx3, toY(_score), _w3, getHeight(_score), ctx, _c3);
        }
      }
    } catch (err) {
      _iterator4.e(err);
    } finally {
      _iterator4.f();
    }
  }
  // second pass: draw clipping
  // avoid persisting the red fillstyle with save/restore
  ctx.save();
  if (hasClipping) {
    ctx.fillStyle = clipColor;
    var _iterator5 = _createForOfIteratorHelper(features.values()),
      _step5;
    try {
      for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
        var _feature5 = _step5.value;
        var _featureSpanPx9 = featureSpanPx(_feature5, region, bpPerPx),
          _featureSpanPx10 = _slicedToArray(_featureSpanPx9, 2),
          _leftPx4 = _featureSpanPx10[0],
          _rightPx4 = _featureSpanPx10[1];
        var _w4 = _rightPx4 - _leftPx4 + fudgeFactor;
        var _score2 = _feature5.get('score');
        if (_score2 > niceMax) {
          fillRectCtx(_leftPx4, offset, _w4, clipHeight, ctx);
        } else if (_score2 < niceMin && scaleOpts.scaleType !== 'log') {
          fillRectCtx(_leftPx4, unadjustedHeight, _w4, clipHeight, ctx);
        }
      }
    } catch (err) {
      _iterator5.e(err);
    } finally {
      _iterator5.f();
    }
  }
  ctx.restore();
  if (displayCrossHatches) {
    ctx.lineWidth = 1;
    ctx.strokeStyle = 'rgba(200,200,200,0.5)';
    ticks.values.forEach(function (tick) {
      ctx.beginPath();
      ctx.moveTo(0, Math.round(toY(tick)));
      ctx.lineTo(width, Math.round(toY(tick)));
      ctx.stroke();
    });
  }
  return {
    reducedFeatures: reducedFeatures
  };
}
export function drawLine(ctx, props) {
  var features = props.features,
    regions = props.regions,
    bpPerPx = props.bpPerPx,
    scaleOpts = props.scaleOpts,
    unadjustedHeight = props.height,
    values = props.ticks.values,
    displayCrossHatches = props.displayCrossHatches,
    colorCallback = props.colorCallback,
    config = props.config,
    _props$offset2 = props.offset,
    offset = _props$offset2 === void 0 ? 0 : _props$offset2;
  var _regions2 = _slicedToArray(regions, 1),
    region = _regions2[0];
  var width = (region.end - region.start) / bpPerPx;
  // the adjusted height takes into account YSCALEBAR_LABEL_OFFSET from the
  // wiggle display, and makes the height of the actual drawn area add
  // "padding" to the top and bottom of the display
  var height = unadjustedHeight - offset * 2;
  var clipColor = readConfObject(config, 'clipColor');
  var scale = getScale(_objectSpread({}, scaleOpts, {
    range: [0, height]
  }));
  var _scale$domain3 = scale.domain(),
    _scale$domain4 = _slicedToArray(_scale$domain3, 2),
    niceMin = _scale$domain4[0],
    niceMax = _scale$domain4[1];
  var toY = function toY(n) {
    return clamp(height - (scale(n) || 0), 0, height) + offset;
  };
  var lastVal;
  var prevLeftPx = -Infinity;
  var reducedFeatures = [];
  var _iterator6 = _createForOfIteratorHelper(features.values()),
    _step6;
  try {
    for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
      var feature = _step6.value;
      var _featureSpanPx11 = featureSpanPx(feature, region, bpPerPx),
        _featureSpanPx12 = _slicedToArray(_featureSpanPx11, 2),
        leftPx = _featureSpanPx12[0],
        rightPx = _featureSpanPx12[1]; // create reduced features, avoiding multiple features per px
      if (Math.floor(leftPx) !== Math.floor(prevLeftPx)) {
        reducedFeatures.push(feature);
        prevLeftPx = leftPx;
      }
      var score = feature.get('score');
      var lowClipping = score < niceMin;
      var highClipping = score > niceMax;
      var w = rightPx - leftPx + fudgeFactor;
      var c = colorCallback(feature, score);
      ctx.beginPath();
      ctx.strokeStyle = c;
      var startPos = typeof lastVal !== 'undefined' ? lastVal : score;
      if (!region.reversed) {
        ctx.moveTo(leftPx, toY(startPos));
        ctx.lineTo(leftPx, toY(score));
        ctx.lineTo(rightPx, toY(score));
      } else {
        ctx.moveTo(rightPx, toY(startPos));
        ctx.lineTo(rightPx, toY(score));
        ctx.lineTo(leftPx, toY(score));
      }
      ctx.stroke();
      lastVal = score;
      if (highClipping) {
        ctx.fillStyle = clipColor;
        ctx.fillRect(leftPx, offset, w, clipHeight);
      } else if (lowClipping && scaleOpts.scaleType !== 'log') {
        ctx.fillStyle = clipColor;
        ctx.fillRect(leftPx, height - clipHeight, w, height);
      }
    }
  } catch (err) {
    _iterator6.e(err);
  } finally {
    _iterator6.f();
  }
  if (displayCrossHatches) {
    ctx.lineWidth = 1;
    ctx.strokeStyle = 'rgba(200,200,200,0.5)';
    values.forEach(function (tick) {
      ctx.beginPath();
      ctx.moveTo(0, Math.round(toY(tick)));
      ctx.lineTo(width, Math.round(toY(tick)));
      ctx.stroke();
    });
  }
  return {
    reducedFeatures: reducedFeatures
  };
}
export function drawDensity(ctx, props) {
  var features = props.features,
    regions = props.regions,
    bpPerPx = props.bpPerPx,
    scaleOpts = props.scaleOpts,
    height = props.height,
    config = props.config;
  var _regions3 = _slicedToArray(regions, 1),
    region = _regions3[0];
  var pivot = readConfObject(config, 'bicolorPivot');
  var pivotValue = readConfObject(config, 'bicolorPivotValue');
  var negColor = readConfObject(config, 'negColor');
  var posColor = readConfObject(config, 'posColor');
  var color = readConfObject(config, 'color');
  var clipColor = readConfObject(config, 'clipColor');
  var crossing = pivot !== 'none' && scaleOpts.scaleType !== 'log';
  var scale = getScale(_objectSpread({}, scaleOpts, {
    pivotValue: crossing ? pivotValue : undefined,
    range: crossing ? [negColor, 'white', posColor] : ['white', posColor]
  }));
  var scale2 = getScale(_objectSpread({}, scaleOpts, {
    range: [0, height]
  }));
  var cb;
  if (color === '#f0f') {
    cb = function cb(_feature, score) {
      return scale(score);
    };
  } else {
    cb = function cb(feature, score) {
      return readConfObject(config, 'color', {
        feature: feature,
        score: score
      });
    };
  }
  var _scale2$domain = scale2.domain(),
    _scale2$domain2 = _slicedToArray(_scale2$domain, 2),
    niceMin = _scale2$domain2[0],
    niceMax = _scale2$domain2[1];
  var prevLeftPx = -Infinity;
  var hasClipping = false;
  var reducedFeatures = [];
  var _iterator7 = _createForOfIteratorHelper(features.values()),
    _step7;
  try {
    for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
      var _feature6 = _step7.value;
      var _featureSpanPx15 = featureSpanPx(_feature6, region, bpPerPx),
        _featureSpanPx16 = _slicedToArray(_featureSpanPx15, 2),
        _leftPx5 = _featureSpanPx16[0],
        _rightPx5 = _featureSpanPx16[1]; // create reduced features, avoiding multiple features per px
      if (Math.floor(_leftPx5) !== Math.floor(prevLeftPx)) {
        reducedFeatures.push(_feature6);
        prevLeftPx = _leftPx5;
      }
      var _score3 = _feature6.get('score');
      hasClipping = hasClipping || _score3 > niceMax || _score3 < niceMin;
      var _w5 = _rightPx5 - _leftPx5 + fudgeFactor;
      ctx.fillStyle = cb(_feature6, _score3);
      ctx.fillRect(_leftPx5, 0, _w5, height);
    }
    // second pass: draw clipping
    // avoid persisting the red fillstyle with save/restore
  } catch (err) {
    _iterator7.e(err);
  } finally {
    _iterator7.f();
  }
  ctx.save();
  if (hasClipping) {
    ctx.fillStyle = clipColor;
    var _iterator8 = _createForOfIteratorHelper(features.values()),
      _step8;
    try {
      for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
        var feature = _step8.value;
        var _featureSpanPx13 = featureSpanPx(feature, region, bpPerPx),
          _featureSpanPx14 = _slicedToArray(_featureSpanPx13, 2),
          leftPx = _featureSpanPx14[0],
          rightPx = _featureSpanPx14[1];
        var w = rightPx - leftPx + fudgeFactor;
        var score = feature.get('score');
        if (score > niceMax) {
          fillRectCtx(leftPx, 0, w, clipHeight, ctx);
        } else if (score < niceMin && scaleOpts.scaleType !== 'log') {
          fillRectCtx(leftPx, 0, w, clipHeight, ctx);
        }
      }
    } catch (err) {
      _iterator8.e(err);
    } finally {
      _iterator8.f();
    }
  }
  ctx.restore();
  return {
    reducedFeatures: reducedFeatures
  };
}